App.factory('zochaPzuwHealthInsuranceService', ['baseService', 'Config', 'healthInsuranceSharedService', 'branchService', function (baseService, Config, healthInsuranceSharedService, branchService) {
    function ZochaPzuwHealthInsuranceService() {

        this.getBranchesForDeclaration = function () {
            return branchService.getZochaAllowedBranchesForDeclarations();
        };

        this.addDeclaration = function (data) {
            data = healthInsuranceSharedService.convertToHealth(data);
            return baseService.post(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw`, data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.getDeclarations = function (data) {
            return baseService.post(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/list`, data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                }).then(function (data) {
                    if (data.status === 200) {
                        let declarations = [];
                        data.data.data.forEach(function (single) {
                            declarations.push(healthInsuranceSharedService.convertFromHealth(single));
                        });
                        data.data.data = declarations;
                    }

                    return data;
                });
        };

        this.getUsersLastActiveDeclaration = function (userId) {
            return baseService.get(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/user/${userId}/lastActive`)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                }).then(function (data) {
                    if (data.status === 200 && data.data) {
                        return healthInsuranceSharedService.convertFromHealth(data.data);
                    } else {
                        return null;
                    }
                });
        };

        this.downloadDeclaration = function (uuid) {
            return baseService.download(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/${uuid}/declaration`)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.downloadStatement = function (uuid) {
            return baseService.download(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/${uuid}/statement`)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.withdrawDeclaration = function (criteria) {
            return baseService.post(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/${criteria.uuid}/withdrawal`, criteria.data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.sendNotification = function (criteria) {
            return baseService.post(`${Config.API_URL}/zocha/healthInsuranceDeclaration/pzuw/${criteria.uuid}/notification`, criteria.data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.getInsurerTransfers = function (criteria) {
            return baseService.get(`${Config.API_URL}/zocha/healthInsurance/transfer/pzuw`, criteria)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };

        this.sendInsurerTransfer = function (data) {
            return baseService.post(`${Config.API_URL}/zocha/healthInsurance/transfer/pzuw`, data)
                .then(function (success) {
                    return success;
                }, function (error) {
                    return error;
                });
        };
    }

    return new ZochaPzuwHealthInsuranceService();
}]);